<template>
  <div v-if="isShowLoading" style="text-align: center; margin-top: 10px">
    <span>
      <a-icon v-if="!isGetAllData" type="loading" />
      {{ isGetAllData ? '没有更多数据了。' : '加载数据。 ' }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'MsgFileItemLoading',
  props: {
    isShowLoading: {
      type: Boolean,
      default: false,
    },
    isGetAllData: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
